/**
 * Application Configuration - CS Admin Frontend
 * 
 * SECURITY IMPROVEMENTS:
 * - No hardcoded environment URLs (uses build-time env vars)
 * - No environment detection logic exposed
 * - No localStorage API switching in production
 * - Only current environment's URLs are in the bundle
 * 
 * Build-time environment variables are replaced during the build process.
 * Two builds: REACT_APP_PORTAL_MODE=cs (company secretary) or csadmin (admin).
 */

// Get configuration from environment variables (replaced at build time)
const API_URL = process.env.REACT_APP_API_URL || '/api/v1';
const ADMIN_URL = process.env.REACT_APP_ADMIN_URL || window.location.origin;
const DIRECTOR_URL = process.env.REACT_APP_DIRECTOR_URL || window.location.origin;
const CSADMIN_URL = process.env.REACT_APP_CSADMIN_URL || window.location.origin;
const CS_PORTAL_URL = process.env.REACT_APP_CS_PORTAL_URL || window.location.origin;
const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || 'development';
const PORTAL_MODE = process.env.REACT_APP_PORTAL_MODE || 'csadmin';
const IS_ADMIN_PORTAL = PORTAL_MODE === 'csadmin';
const AUTH_PATH = process.env.REACT_APP_AUTH_PATH || (IS_ADMIN_PORTAL ? '/auth/csadmin' : '/auth/cs');

/** CRA subpath when hosted under e.g. /companysecretary or /groupcompanysecretary */
function resolvePublicUrl() {
  const fromBuild = process.env.PUBLIC_URL || '';
  if (fromBuild) return fromBuild;
  if (typeof window !== 'undefined') {
    const path = window.location.pathname || '';
    if (path === '/companysecretary' || path.startsWith('/companysecretary/')) {
      return '/companysecretary';
    }
    if (path === '/groupcompanysecretary' || path.startsWith('/groupcompanysecretary/')) {
      return '/groupcompanysecretary';
    }
    // Legacy paths (pre-rename)
    if (path === '/cs' || path.startsWith('/cs/')) {
      return '/cs';
    }
    if (path === '/csadmin' || path.startsWith('/csadmin/')) {
      return '/csadmin';
    }
  }
  return '';
}

const PUBLIC_URL = resolvePublicUrl();

export const PORTAL_TITLES = {
  cs: 'Company Secretary Portal',
  csadmin: 'Group Company Secretary Portal',
};

// Simple, secure configuration - no conditional logic, no environment detection
export const API_CONFIG = {
  BASE_URL: API_URL,
  ADMIN_URL,
  DIRECTOR_URL,
  CSADMIN_URL,
  CS_PORTAL_URL,
  ENVIRONMENT,
  PORTAL_MODE,
  IS_ADMIN_PORTAL,
  AUTH_PATH,
  PORTAL_TITLE: IS_ADMIN_PORTAL ? PORTAL_TITLES.csadmin : PORTAL_TITLES.cs,
  TIMEOUT: 30000,

  getCurrentApiUrl: () => API_URL,
  getAdminUrl: () => ADMIN_URL,
  getDirectorUrl: () => DIRECTOR_URL,
  getCSAdminUrl: () => CSADMIN_URL,
  getCsPortalUrl: () => CS_PORTAL_URL,
  PUBLIC_URL,
  loginPath: `${PUBLIC_URL}/login`,
};

/** True for local/dev appstaging builds — not UAT or production. */
export function isDevEnvironment() {
  const env = String(API_CONFIG.ENVIRONMENT || '').toLowerCase();
  return env === 'development' || env === 'dev';
}

const config = { API_CONFIG };
export default config;

export const secureLog = (...args) => {
  if (process.env.NODE_ENV === 'development') {
    console.log(...args);
  }
};
